module.exports = __webpack_public_path__ + "img/cssbj.599dddaa.png";